import Carousel from "@Components/Carousel";
import CarouselIndicator from "@Components/Carousel/components/CarouselIndicator";
import LazyImage from "@Components/Image";
import getImagePath from "@Utils/getImagePath";
import { useState } from "react";
import styles from "./ImageSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import {
  getVideoSrc,
  getVideoThumb,
} from "@Pages/PropertyPage/components/SectionFeatured.tsx/utils";
import loadable from "@loadable/component";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const VideoPlayer = loadable(() => import("@Components/VideoPlayer"));
interface IImageSectionProps {
  images: string[];
  index: number;
  dataTestId?: string;
  videos: any[];
  isDesktop: boolean;
  noRedius?: boolean;
  className?: string;
  altData?: string;
  maxDots?: number;
  isGridView?: boolean;
  isMiniProgram?: boolean;
}

const ImageSection = (props: IImageSectionProps) => {
  const {
    images,
    index,
    dataTestId,
    videos,
    isDesktop,
    noRedius,
    className,
    altData,
    maxDots,
    isGridView,
    isMiniProgram = false,
  } = props;
  const filteredVideos = videos.filter((video: any) => !video.path.includes("youtube")) || [];
  const virtualTourVideos = videos?.filter((video: any) => video.type === "vo_tour");
  const sortedVideos = virtualTourVideos?.sort(
    (v1: any, v2: any) => parseFloat(v2?.duration) - parseFloat(v1?.duration),
  );
  const videoItem = sortedVideos?.length ? sortedVideos[0] : filteredVideos[0];
  const [activePos, setActivePos] = useState(1);

  const handleChangeSlide = (pos: number) => setActivePos(pos);

  const medias =
    videoItem && images.length > 1
      ? [images[0], images[1], videoItem, ...images.slice(2, 4)]
      : images;

  return (
    <div
      className={formatClassNames(
        isDesktop ? styles.desktopContainer : styles.container,
        !noRedius && styles.addRedius,
        className,
        isGridView && styles.gridView,
      )}
    >
      <Carousel
        slideList={medias.map((media: any, slideIndex: any) =>
          media.path ? (
            <>
              {activePos >= 2 ? (
                <VideoPlayer
                  id={media?.path}
                  name="virtual_video_fullscreen"
                  isLazyLoaded
                  videoUrl={getVideoSrc(media, 400)}
                  autoplay
                  playsInline
                  inLoop
                  noControls
                  muted
                  posterUrl={getVideoThumb(media, {
                    height: isDesktop ? 230 : 215,
                    width: 400,
                  })}
                  isDesktop={isDesktop}
                />
              ) : (
                <></>
              )}
            </>
          ) : (
            <LazyImage
              key={getImagePath(media, "gallery-image-small")}
              isEagerLoad={index <= 1 && slideIndex === 0 && !isMiniProgram}
              src={getImagePath(media, "gallery-image-small")}
              width="100%"
              height="100%"
              rootMargin="0px 0px 0px 0px"
              dataTestId={dataTestId}
              alt={altData || "main"}
              className={styles.imgClass}
            />
          ),
        )}
        activePos={activePos}
        showNavOnHover={isDesktop || isGridView}
        handleChangeSlide={handleChangeSlide}
        className={
          isDesktop
            ? styles.desktopContainer
            : formatClassNames(styles.container, isGridView && styles.gridView)
        }
      />
      <CarouselIndicator
        activeDot={activePos}
        totalSlider={medias.length}
        handleClickIndicator={handleChangeSlide}
        indicatorWrapperClassName={styles.indicator}
        type="line"
        activeDotColor="#fff"
        maxDots={maxDots}
      />
    </div>
  );
};

export default wrapperHOC(ImageSection, {
  componentName: "ImageSection-SearchListItemDesktop-SearchPage",
  showForChina: true,
});
